import { MprcContainer } from "components";
import { usePageTitle } from "hooks/usePageTitle";
import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { HomeBanner } from "views/home/HomeBanner";
import { HomeCarousel } from "views/home/HomeCarousel";
import { HomeDialogs } from "views/home/HomeDialogs";
import { HomeIndicator } from "views/home/HomeIndicator";
import { HomeWelcome } from "views/home/HomeWelcome";

export type HomeCarouselProps = {
    onEmptyDataset: () => void;
};

export const Welcome: React.FC = () => {
    const { t } = useTranslation("shared");

    usePageTitle(t("App.Menu.Sidebar.Home"));

    const [dsCounter, setDsCounter] = useState(0);

    return (
        <div>
            <HomeDialogs />

            <HomeBanner />

            {dsCounter == 2 && <HomeWelcome />}

            <HomeIndicator onEmptyDataset={() => setDsCounter(state => state + 1)} />

            <MprcContainer margin="none">
                <HomeCarousel onEmptyDataset={() => setDsCounter(state => state + 1)} />
            </MprcContainer>
        </div>
    );
};
